import { Translate } from "components/common/Translate/Translate";
import { CompressionSettings } from "../Components/CompressionSettings/CompressionSettings";
import { CompressCompare } from "../Preview/CompressCompare/CompressCompare";
import { ApplyButtons } from "./ApplyButtons/ApplyButtons";
import { useApplyButtons } from "./ApplyButtons/useApplyButtons";
import { useEditSettings } from "./useEditSettings";

export const EditSettings = () => {
    const { selectedImage, handleMaxFileSizeChange, handleQualityChange, handleTypeChange, isMaxFileSizeDisabled } =
        useEditSettings();
    const { onQualityChangeApply } = useApplyButtons();

    if (selectedImage === null) {
        return (
            <div
                className="mx-7 bg-irGray-100 dark:bg-darkSurface-200 h-full border border-irGray-400 dark:border-darkSurface-400 border-dashed flex items-center justify-center"
                data-testid="no-image-element"
            >
                <div
                    className="bg-irBlue-200 dark:bg-darkPrimary-100 mx-auto"
                    style={{ width: "300px", height: "250px" }}
                ></div>
            </div>
        );
    }

    if (selectedImage.hasExpired) {
        return (
            <div
                className="text-center font-semibold text-xl my-auto h-full text-black dark:text-white"
                data-testid="expired-element"
            >
                <Translate keyName="expired-image-label" />
            </div>
        );
    }

    return (
        <div className="flex flex-col h-full max-h-full min-h-0 overflow-x-hidden scroll lg:gap-4">
            <div className="lg:py-2 lg:px-2 dark:bg-darkSurface-200 flex flex-col lg:flex-row items-center gap-2 border border-irGray-200 dark:border-darkSurface-400 mx-2">
                <div className="w-full">
                    <CompressionSettings
                        type={selectedImage.compressionSettings.type}
                        maxFileSize={selectedImage.compressionSettings.maxFileSize}
                        quality={selectedImage.compressionSettings.quality}
                        handleMaxFileSizeChange={(size) => handleMaxFileSizeChange(size, selectedImage.id)}
                        handleQualityChange={(quality) => handleQualityChange(quality, selectedImage.id)}
                        handleTypeChange={(type) => handleTypeChange(type, selectedImage.id)}
                        isMaxFileSizeDisabled={isMaxFileSizeDisabled}
                        isQualityDisabled={selectedImage.state === "compressing"}
                        handleApply={onQualityChangeApply}
                    />
                </div>
                <div className="ml-auto mx-4">
                    <ApplyButtons image={selectedImage} type={selectedImage.compressionSettings.type} />
                </div>
            </div>
            <div className="flex-grow">
                <CompressCompare image={selectedImage} />
            </div>
        </div>
    );
};
